import { SubRange } from '../../../engine'
import { anim, prog, pv, stagger } from '../../../motion'
import { Phone, Shape } from '../../../primitives'
import { GAME_TEXT, GameScreens } from '../../../scenes/SceneGames'
import { Fit, Line } from '../../../v2/kit'
import { useCopy, useLang } from '../../i18n'

const STRENGTH_SHAPES = [
  ['dot', 'pink'],
  ['tri', 'yellow'],
  ['sq', 'green']
]

// Schritt-Symbole wie im Entwurf: Viertelkreis, Kreis, Halbkreis
const STEP_ICONS = ['quarter', 'full', 'half']

// Bereiche der drei Schritte im Kapitel
const STEPS = [
  { at: [0.14, 0.2], out: [0.3, 0.34], side: 'left' },
  { at: [0.36, 0.42], out: [0.74, 0.78], side: 'right' },
  { at: [0.82, 0.88], side: 'left' }
]

const NARROW = { maxW: 0.66, maxH: 0.5 }

// Das Smartphone richtet sich auf, dann Mail, Spiele und Stärkenprofil, unten die drei Schritte
export default function CandFlow() {
  const c = useCopy('ablauf')
  const lang = useLang()

  return (
    <div className='cin-full'>
      <Line
        at={[0, 0.05]}
        out={[0.1, 0.14]}
        className='cin-display ch-flow-title'
      >
        {c.title}
      </Line>

      {c.steps.map((s, i) => (
        <div
          key={s.title}
          className={`cin-caption cin-caption--${STEPS[i].side} ch-step-caption`}
          style={anim({ at: STEPS[i].at, out: STEPS[i].out, y: 40, oy: -40 })}
        >
          <span className={`ch-step-icon ch-step-icon--${STEP_ICONS[i]}`} />
          <div className='cin-eyebrow cin-eyebrow--light'>{i + 1} / 3</div>
          <div className='cin-caption__text'>{s.title}</div>
          <p className='ch-step-caption__text'>{s.text}</p>
        </div>
      ))}

      <div className='ch-steps' style={anim({ at: [0.12, 0.18], y: 30 })}>
        {c.steps.map((s, i) => (
          <div
            key={s.title}
            className='ch-steps__item'
            style={{
              ...pv('f', STEPS[i].at),
              ...pv('g', STEPS[i].out || [2, 3])
            }}
          >
            <span className='ch-steps__num'>{i + 1}</span>
            <span className='ch-steps__label'>{s.title}</span>
          </div>
        ))}
      </div>

      <Fit
        w={260}
        h={540}
        maxH={0.74}
        maxW={0.5}
        narrow={NARROW}
        className='cin-phone-fit ch-phone-fit'
      >
        <div
          className='cin-phone-3d'
          style={{
            ...prog([0, 0.14]),
            transform:
              'translateY(calc((1 - var(--p)) * 220px)) rotateX(calc((1 - var(--p)) * 58deg)) ' +
              'rotateZ(calc((1 - var(--p)) * 24deg)) scale(calc(0.72 + 0.28 * var(--p)))'
          }}
        >
          <Phone x={0} y={0}>
            <div
              className='sty-abs sty-screen ch-mail'
              style={anim({ at: [-1, 0], out: [0.19, 0.21], y: 0, oy: -20 })}
            >
              <div className='sty-h4'>{c.inbox}</div>
              <div
                className='ch-mail__item ch-mail__item--new'
                style={anim({ at: [0.12, 0.16], y: -60, s: 0.9 })}
              >
                <span className='ch-mail__dot' />
                <div>
                  <div className='sty-strong sty-small'>{c.sender}</div>
                  <div className='sty-small'>{c.subject}</div>
                  <div className='sty-muted sty-small'>{c.preview}</div>
                </div>
              </div>
              {[0, 1, 2].map((k) => (
                <div key={k} className='ch-mail__item'>
                  <i style={{ width: '46%' }} />
                  <i style={{ width: '80%' }} />
                </div>
              ))}
            </div>

            <div
              className='sty-abs sty-screen ch-mail'
              style={anim({
                at: [0.21, 0.24],
                out: [0.31, 0.33],
                x: 40,
                y: 0,
                oy: -20
              })}
            >
              <div className='sty-muted sty-small'>{c.sender}</div>
              <div className='sty-strong sty-mt-1'>{c.subject}</div>
              <div className='ch-mail__body'>
                <p>{c.greeting}</p>
                <p>{c.body}</p>
              </div>
              <div
                className='sty-btn sty-btn--full ch-mail__btn'
                style={prog([0.27, 0.3])}
              >
                {c.button}
              </div>
            </div>

            <SubRange
              at={[0.34, 0.78]}
              className='sty-abs cin-inset'
              style={anim({
                at: [0.32, 0.35],
                out: [0.78, 0.81],
                y: 20,
                oy: -20
              })}
            >
              <GameScreens text={GAME_TEXT[lang]} />
            </SubRange>

            <div
              className='sty-abs sty-screen'
              style={anim({ at: [0.8, 0.84], y: 20 })}
            >
              <div className='sty-feedback-head'>
                <div className='sty-h4 sty-center'>{c.profile}</div>
              </div>
              {c.strengths.map((s, i) => (
                <div
                  key={s.title}
                  className='sty-strength'
                  style={anim({ at: stagger(0.84, 0.03, 0.06, i), y: 24 })}
                >
                  <Shape
                    kind={STRENGTH_SHAPES[i][0]}
                    color={STRENGTH_SHAPES[i][1]}
                    size={26}
                  />
                  <div>
                    <div className='sty-strong'>{s.title}</div>
                    <div className='sty-muted sty-small'>{s.text}</div>
                  </div>
                </div>
              ))}
            </div>
          </Phone>
        </div>
      </Fit>
    </div>
  )
}
